import React,{useEffect,useRef} from "react";
import {Box,Typography,Container} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import "./roadmap.css";
import {setupRoadmapAnimations} from "../animations/roadmapsAnimation";
import colors from "../../../../theme/colors";
import typography from "../../../../theme/typography";

const roadmapItems=[
  {
    quarter:"Q1 2025",
    title:"Platform Launch",
    points:[
      "Core Lottery System",
      "Smart Contract Integration",
      "Initial Game Suite"
    ]
  },
  {
    quarter:"Q2 2025",
    title:"Game Expansion",
    points:[
      "New Game Experiences",
      "Additional Betting Options",
      "Mobile Optimization"
    ]
  },
  {
    quarter:"Q3 2025",
    title:"Ecosystem Growth",
    points:[
      "Token Utilities",
      "Community Features",
      "Global Expansion"
    ]
  },
  {
    quarter:"Q4 2025",
    title:"Community & Beyond",
    points:[
      "Community Governance",
      "More Games",
      "Strategic Partnerships"
    ]
  }
];

const Roadmap=()=>{
  const theme = useTheme();
  const sectionRef=useRef(null);
  const stageRef=useRef(null);
  const trackRef=useRef(null);
  const itemRefs=useRef([]);
  const centerRef=useRef(null);

  useEffect(()=>{
    return setupRoadmapAnimations({
      sectionRef,
      stageRef,
      trackRef,
      itemRefs,
      roadmapItems
    });
  },[]);

  return(
    <Box
      ref={sectionRef}
      component="section"
      className="roadmap-section"
      sx={(theme) => ({
        px: {
          ...theme.custom["home-section-left-padding"],
          xs: theme.custom.layoutSizes.mobileStandard.padding.leftRight,
        },
        pt: {
          xs: theme.custom.layoutSizes.mobileStandard.padding.topBottom,
          sm: theme.custom.layoutSizes.section.paddingTop,
        },
        pb: {
          xs: theme.custom.layoutSizes.mobileStandard.padding.topBottom,
          sm: theme.custom.layoutSizes.section.paddingBottom,
        },
      })}
    >
      <Container 
        maxWidth={false}
        disableGutters
        sx={{
          width: "100%",
          maxWidth: "1400px",
          mx: "auto",
        }}
      >
        <Box 
          className="roadmap-header"
          sx={(theme) => ({
            ...(theme.typography.homeSection?.headerContainer || {}),
            mb: theme.typography.homeSection?.headerBottomMargin || { xs: 4, md: 5 },
          })}
        >
          <Typography
            component="p"
            className="roadmap-eyebrow"
            sx={(theme) => ({
              ...(theme.typography.homeSection?.eyebrow || {}),
              fontSize: {
                xs: theme.custom.layoutSizes.mobileStandard.typography.eyebrow.fontSize,
                md: theme.typography.homeSection?.eyebrow?.fontSize?.md,
              },
              marginBottom: {
                xs: theme.custom.layoutSizes.mobileStandard.typography.eyebrow.marginBottom,
                md: theme.typography.homeSection?.eyebrow?.marginBottom?.md,
              },
              color: "primary.main",
              whiteSpace: "nowrap",
              "&::before": {
                ...(theme.typography.homeSection?.eyebrow?.["&::before"] || {}),
                background: theme.palette.primary.main,
              },
            })}
          >
            ROADMAP
          </Typography>

          <Typography
            component="h2"
            className="roadmap-heading"
            sx={(theme) => ({
              ...(theme.typography.homeSection?.heading || {}),
              fontSize: {
                xs: theme.custom.layoutSizes.mobileStandard.typography.heading.fontSize,
                md: theme.typography.homeSection?.heading?.fontSize?.md,
              },
              color: theme.custom.colors.home.navyDark,
            })}
          >
            Our Journey Forward
          </Typography>

          <Typography 
            className="roadmap-description"
            sx={(theme) => ({
              ...(theme.typography.homeSection?.description || {}),
              fontSize: {
                xs: theme.custom.layoutSizes.mobileStandard.typography.paragraph.fontSize,
                md: theme.typography.homeSection?.description?.fontSize?.md,
              },
              color: "text.secondary",
              maxWidth: "600px",
              mt: 2,
            })}
          >
            Follow the key milestones shaping the future of AutoBET
            as we build a transparent and engaging gaming ecosystem.
          </Typography>
        </Box>

      <Box
        ref={stageRef}
        className="roadmap-stage"
      >

        <Box
          ref={trackRef}
          className="roadmap-track"
        >
          <Box className="roadmap-line"/>

          {roadmapItems.map((item,index)=>(
            <Box
              key={item.quarter}
              ref={element=>{
                itemRefs.current[index]=element;
              }}
              className={`roadmap-item roadmap-item-${index} ${index % 2 === 0 ? 'roadmap-item-left' : 'roadmap-item-right'}`}
            >
              <Box className="roadmap-bullet">
                <Box className="roadmap-bullet-inner"/>
              </Box>

              <Box className="roadmap-card">
                <Typography className="roadmap-quarter" sx={{ color: colors.slate[500], fontFamily: typography.fontFamily }}>
                  {item.quarter}
                </Typography>

                <Typography className="roadmap-title" sx={{ color: colors.home.navyDeep, fontFamily: typography.h3.fontFamily }}>
                  {item.title}
                </Typography>

                <Box className="roadmap-points">
                  {item.points.map(point=>(
                    <Box
                      key={point}
                      className="roadmap-point"
                    >
                      <Box className="roadmap-check">
                        ✓
                      </Box>

                      <Typography className="roadmap-point-text" sx={{ color: colors.text.secondary, fontFamily: typography.fontFamily }}>
                        {point}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      </Container>
    </Box>
  );
};

export default Roadmap;